(() => {
	angular
		.module('main')
		.controller('ClientContactFormController', ClientContactFormController);

	ClientContactFormController.$inject = [
		'$scope',
		'$rootScope',
		'$routeParams',
		'$http',
		'$window',
		'timeService',
		'messageService',
		'settingsService',
		'accountService'
	];

	function ClientContactFormController(
		$scope,
		$rootScope,
		$routeParams,
		$http,
		$window,
		timeService,
		messageService,
		settingsService,
		accountService
	) {
		Intercom('shutdown');
		accountService.emitShowHeader(false);
		$rootScope.showLogo = false;
		$scope.onLoad = true;
		$scope.isFormSubmitted = false;
		$rootScope.isContactForm = true;
		$scope.jobTypes = [];
		$scope.otherQuestionsIds = [];
		$scope.isSubmitSpinningWheelActive = false;
		$scope.todayDate = new Date().toJSON().split('T')[0];
		$scope.inputPatter = {
			nonEmpty: '[\\s\\S]*\\S[\\s\\S]*',
			email: '[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,9}$',
			phone: '/^[0-9\\s(-)]*$/'
		};
		// console.log('previewContactForm', $rootScope.previewContactForm);

		$scope.isPriviewContactFormPage = $routeParams.id;

		document.title = 'Contact Form';

		$scope.$on('$viewContentLoaded', () => {
			// $('.embedContactForm__input').datepicker({ format: 'dd-mm-yyyy' });

			// document.cookie = "reCAPTCHA_token=true";

			$scope.isTest = document.cookie.includes('reCAPTCHA_token');
			window.scrollTo(0, 0);

			if ($scope.isPriviewContactFormPage == 'preview') {
				if (!$rootScope.previewContactForm) {
					$rootScope.previewContactForm = JSON.parse($routeParams.contactForm);
				}

				let previewData = $rootScope.previewContactForm;

				$http
					.get(`/public/rest/contactform/${$routeParams.photographyStudio}`)
					.then(
						result => {
							if (result.data) {
								setDatePickerPlaceholder(result.data.calendarDateFormat);
								setDateFormat(
									result.data.calendarDateFormat,
									result.data.weekStartsOn
								);
								const tmpObj = {
									companyName: result.data.companyName,
									companyBanner: result.data.companyBanner,
									companyLogo: result.data.companyLogo,
									fields: $rootScope.previewContactForm,
									gdprEnabled: result.data.gdprEnabled,
									optInConsent: result.data.optInConsent,
									optInConsentStatement: result.data.optInConsentStatement
								};

								previewData = Object.assign(
									tmpObj,
									$rootScope.previewContactForm
								);
							}
						},
						result => {
							const tmpError = result.data.errorMessage || 'Error';
							toastr.error(tmpError, 'Wrong link');
						}
					)
					.then(() => {
						convertFormData(previewData);
						$scope.onLoad = false;
					});
			} else {
				getContactFormInformation();
			}
		});

		const fieldsOptions = {
			FIRST_NAME: { isMultilined: false, name: 'First name' },
			LAST_NAME: { isMultilined: false, name: 'Last name' },
			EMAIL: { isMultilined: false, name: 'Email' },
			PHONE: { isMultilined: false, name: 'Phone' },
			MESSAGE: {
				isMultilined: true,
				name: 'Message (appears in client notes)'
			},
			JOB_TYPE: {
				isMultilined: false,
				name: 'Job type (appears in client notes)'
			},
			JOB_DATE: {
				isMultilined: false,
				name: 'Main shoot date (appears in client notes)'
			},
			JOB_LOCATION: {
				isMultilined: false,
				name: 'Job location (appears in client notes)'
			},
			ENQUIRY_SOURCE: {
				isMultilined: false,
				name: 'Enquiry source (appears in client notes)'
			}
		};

		function validPhone() {
			const re = /^\d[\d\(\)\ -]{4,14}\d$/;
			const phone = document.getElementById('phone').value;
			if (re.test(phone)) {
				return true;
			}
			return false;
		}

		function validEmail() {
			const re = /^[\w-\.]+@[\w-]+\.[a-z]{2,4}$/i;
			const emailValue = document.getElementById('emailId').value;
			if (re.test(emailValue)) {
				return true;
			}
			return false;
		}

		function setDatePickerPlaceholder(dateFormat) {
			let placeholder;

			if (dateFormat) {
				placeholder = dateFormat === 'DD_MM_YYYY' ? 'dd/mm/yyyy' : 'mm/dd/yyyy';
			}

			$scope.datePickerPlaceholder = placeholder || 'mm/dd/yyyy';
		}

		function setDateFormat(dateFormat, weekStartsDate) {
			settingsService.dateFormatPattern(dateFormat, weekStartsDate);
		}

		function convertFormData(data) {
			document.title = `${`${data.companyName} - ` || ''}Contact Form`;

			$rootScope.companyBanner = data.companyBanner || '';
			$rootScope.companyLogo = data.companyLogo || '';

			$scope.contactFormId = data.id;
			$scope.jobTypes = data.jobTypes;

			$scope.fields = data.fields.map(item =>
				// return item item.fieldType;
				Object.assign(item, fieldsOptions[item.fieldType])
			);

			$scope.introductionMessage = data.introductionMessage;
			$scope.thanksMessage = data.thanksMessage;

			$scope.showOptInConsent = data.optInConsent;
			$scope.optInConsentStatement = data.optInConsentStatement;
			$scope.gdprEnabled = data.gdprEnabled;

			$scope.$evalAsync();
		}

		function getContactFormInformation() {
			$http
				.get(`/public/rest/contactform/${$routeParams.photographyStudio}`)
				.then(
					result => {
						if (result.data) {
							setDatePickerPlaceholder(result.data.calendarDateFormat);
							setDateFormat(
								result.data.calendarDateFormat,
								result.data.weekStartsOn
							);
							convertFormData(result.data);
						}
					},
					result => {
						const tmpError = result.data.errorMessage || 'Error';
						toastr.error(tmpError, 'Wrong link');
						$scope.contactForm = {};
					}
				)
				.then(() => {
					$scope.onLoad = false;
				});
		}

		$scope.submitForm = function(token) {
			$scope.isSubmitSpinningWheelActive = true;

			if ($scope.isSubmitSpinningWheelActive === true) {
				const data2Save = fillContactFormData4Save();
				data2Save.reCaptchaToken = token;
				if ($scope.gdprEnabled && $scope.showOptInConsent) {
					data2Save.optInConsent = $scope.optInConsent;
				}
				$http({
					method: 'POST',
					url: `/public/rest/contactform/${$scope.contactFormId}`,
					data: data2Save
				})
					.then(result => {
						messageService.showToaster('s_1', 'contactForm');
						$scope.isFormSubmitted = true;
					})
					.then(() => {
						$scope.isSavingData = false;
						$scope.isSubmitSpinningWheelActive = false;
					});
			}
		};
		$window.submitForm = $scope.submitForm;

		$scope.validateForm = function() {
			$scope.isSubmitSpinningWheelActive = true;
			$scope.isFirstName = true;
			$scope.isPhone = true;
			$scope.isLastName = true;
			$scope.isMessage = true;
			$scope.isJobType = true;
			$scope.isJobDate = true;
			$scope.isJobLocation = true;
			$scope.isEniquirySource = true;
			$scope.isOther = {};

			$scope.otherQuestionsIds.forEach(id => {
				$scope.isOther[id] = true;
			});

			const isFormValid = checkContactFormData4Save();
			if (!$scope.isTest) {
				grecaptcha.reset($scope.id);
				if (isFormValid) {
					grecaptcha.execute($scope.id);
				} else {
					grecaptcha.reset($scope.id);
				}
			} else {
				$scope.submitForm(null);
			}
		};

		$scope.checkOtherQuestionField = function(id) {
			if ($scope.isOther) return $scope.isOther[id];
			return true;
		};

		$window.validateForm = $scope.validateForm;

		$scope.$watch(
			'wathing',
			() => {
				if ($scope.wathing !== undefined) {
					$scope.wathing.forEach((item, i, arr) => {
						if (
							item.value !== undefined &&
							item.value !== '' &&
							item.fieldType === 'FIRST_NAME'
						) {
							$scope.isFirstName = true;
						} else if (
							item.value !== undefined &&
							item.value !== '' &&
							item.fieldType === 'LAST_NAME'
						) {
							$scope.isLastName = true;
						} else if (
							item.value !== undefined &&
							item.value !== '' &&
							item.fieldType === 'PHONE'
						) {
							$scope.isPhone = true;
						} else if (
							item.value !== undefined &&
							item.value !== '' &&
							item.fieldType === 'EMAIL'
						) {
							$scope.email = true;
						} else if (
							item.value !== undefined &&
							item.value !== '' &&
							item.fieldType === 'MESSAGE'
						) {
							$scope.isMessage = true;
						} else if (
							item.value !== undefined &&
							item.value !== '' &&
							item.fieldType === 'JOB_TYPE'
						) {
							$scope.isJobType = true;
						} else if (
							item.value !== undefined &&
							item.value !== '' &&
							item.fieldType === 'JOB_DATE'
						) {
							$scope.isJobDate = true;
						} else if (
							item.value !== undefined &&
							item.value !== '' &&
							item.fieldType === 'JOB_LOCATION'
						) {
							$scope.isJobLocation = true;
						} else if (
							item.value !== undefined &&
							item.value !== '' &&
							item.fieldType === 'ENQUIRY_SOURCE'
						) {
							$scope.isEniquirySource = true;
						} else {
							$scope.otherQuestionsIds.forEach(id => {
								if (
									item.value !== undefined &&
									item.value !== '' &&
									item.fieldType === 'OTHER' &&
									item.id === id
								) {
									$scope.isOther[id] = true;
								}
							});
						}
					});
				}
			},
			true
		);

		function checkContactFormData4Save() {
			const result = {
				fields: []
			};
			let isFormValid = true;

			$scope.wathing = [];
			$scope.fields.forEach((item, i, arr) => {
				if (
					(item.value === undefined || item.value === '') &&
					item.mandatory === true &&
					item.fieldType === 'FIRST_NAME'
				) {
					$scope.isFirstName = false;
					$scope.first = true;
					$scope.isSubmitSpinningWheelActive = false;
					$scope.wathing.push(item);
					// grecaptcha.reset();
					isFormValid = false;
					return false;
				} else if (
					item.value === undefined &&
					item.mandatory === true &&
					item.fieldType === 'EMAIL'
				) {
					const emailValue = document.getElementById('emailId').value;
					if (emailValue && validEmail() === false) {
						$scope.email = false;
						$scope.emailValid = true;
						$scope.isSubmitSpinningWheelActive = false;
						$scope.wathing.push(item);
						// grecaptcha.reset();
						isFormValid = false;
						return false;
					}
					$scope.email = true;
					$scope.isSubmitSpinningWheelActive = false;
					// grecaptcha.reset();
					isFormValid = false;
					return false;
				} else if (
					(item.value === undefined || item.value === '') &&
					item.mandatory === true &&
					item.fieldType === 'LAST_NAME'
				) {
					$scope.isLastName = false;
					$scope.last = true;
					$scope.isSubmitSpinningWheelActive = false;
					$scope.wathing.push(item);
					// grecaptcha.reset();
					isFormValid = false;
					return false;
				} else if (
					item.value === undefined &&
					item.mandatory === true &&
					item.fieldType === 'PHONE'
				) {
					$scope.phone = true;
					$scope.isPhone = false;
					$scope.isSubmitSpinningWheelActive = false;
					$scope.wathing.push(item);
					// grecaptcha.reset();
					isFormValid = false;
					return false;
				}
				// else if (item.value !== undefined && item.fieldType === "PHONE" && validPhone()===false) {
				//     $scope.phoneValid=true;
				//     $scope.isSubmitSpinningWheelActive = false;
				//     $scope.wathing.push(item);
				//     grecaptcha.reset();
				//     return false;
				// }
				else if (
					(item.value === undefined || item.value === '') &&
					item.mandatory === true &&
					item.fieldType === 'MESSAGE'
				) {
					$scope.isMessage = false;
					$scope.message = true;
					$scope.isSubmitSpinningWheelActive = false;
					$scope.wathing.push(item);
					// grecaptcha.reset();
					isFormValid = false;
					return false;
				} else if (
					item.value === undefined &&
					item.mandatory === true &&
					item.fieldType === 'JOB_TYPE'
				) {
					$scope.isJobType = false;
					$scope.type = true;
					$scope.isSubmitSpinningWheelActive = false;
					$scope.wathing.push(item);
					// grecaptcha.reset();
					isFormValid = false;
					return false;
				} else if (
					(item.value === undefined || item.value === '') &&
					item.mandatory === true &&
					item.fieldType === 'JOB_DATE'
				) {
					$scope.isJobDate = false;
					$scope.date = true;
					$scope.isSubmitSpinningWheelActive = false;
					$scope.wathing.push(item);
					// grecaptcha.reset();
					isFormValid = false;
					return false;
				} else if (
					(item.value === undefined || item.value === '') &&
					item.mandatory === true &&
					item.fieldType === 'JOB_LOCATION'
				) {
					$scope.isJobLocation = false;
					$scope.location = true;
					$scope.isSubmitSpinningWheelActive = false;
					$scope.wathing.push(item);
					// grecaptcha.reset();
					isFormValid = false;
					return false;
				} else if (
					(item.value === undefined || item.value === '') &&
					item.mandatory === true &&
					item.fieldType === 'ENQUIRY_SOURCE'
				) {
					$scope.isEniquirySource = false;
					$scope.sourseEuquiry = true;
					$scope.isSubmitSpinningWheelActive = false;
					$scope.wathing.push(item);
					// grecaptcha.reset();
					isFormValid = false;
					return false;
				}
				$scope.otherQuestionsIds.forEach(id => {
					if (
						(item.value === undefined || item.value === '') &&
						item.mandatory === true &&
						item.fieldType === 'OTHER' &&
						item.id === id
					) {
						$scope.isOther[id] = false;
						$scope.isSubmitSpinningWheelActive = false;
						$scope.wathing.push(item);
						// grecaptcha.reset();
						isFormValid = false;
						return false;
					}
				});
			});

			return isFormValid;
		}
		function fillContactFormData4Save() {
			const result = {
				fields: []
			};

			$scope.fields.forEach((item, i, arr) => {
				if (item.fieldType === 'JOB_TYPE') {
					if (item.value === undefined) {
						result.fields.push({
							data: '',
							contactFormFieldId: item.id
						});
					} else {
						result.fields.push({
							data: item.value.id || '',
							contactFormFieldId: item.id
						});
					}
				} else if (item.fieldType === 'JOB_DATE') {
					item.value = timeService.getDateInFormat(item.value, 'date');
					result.fields.push({
						data: item.value || '',
						contactFormFieldId: item.id
					});
				} else {
					result.fields.push({
						data: item.value || '',
						contactFormFieldId: item.id
					});
				}
			});
			return result;
		}

		$scope.closeWindow = function() {
			$window.close();
		};

		$scope.$on('$destroy', () => {
			$rootScope.isContactForm = false;
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/clientsPortal/ClientContactFormController.js